import Head from 'next/head';

const Meta = () => (
  <Head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta charSet="utf-8" />
    <link rel="shortcut icon" href="/static/favicon.png" />
    <link
      href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700"
      rel="stylesheet"
    />
    <link rel="canonical" href="https://1800accountant.com/products/bookkeeping" />
    <title>ClientBooks - Small-Business Bookkeeping</title>
  </Head>
);

export default Meta;
